import { ReferenceDataDto } from '../../generated/auth/models/Sasfin/Dynamics/Api/Client/Models/DTO/reference-data-dto';

export interface IIndustriesOrSectorsState {
  list: ReferenceDataDto[];
  isLoading: boolean;
}

export const initialUIState: IIndustriesOrSectorsState = {
  list: [],
  isLoading: false,
};